<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-24 11:33:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-25 17:56:42
-->
<template>
  <!-- 企业设置 -->
  <div>
    <div v-if="$route.name == 'enterprise'">
      <mrc_ess_addBtn v-if="hasBtn('add-organization-configuration')"
                      @handleAdd="handleAdd"></mrc_ess_addBtn>
      <!-- <router-link
      v-if="$route.name == 'enterprise'"
      to="/enterprise/enterpriseInfo"
    >企业设置</router-link> -->
      <mrc_ess_skeleton_loader :loading="skLoading">
        <v-card>
          <v-card-text class="px-8">
            <div class="text--secondary pb-3 pl-10">
              <!-- {{ $t('label_client') }}/{{ $t('label_company_unit') }} -->
              {{$t('label_org_m_name')}}
            </div>
            <template v-if="Array.isArray(companyList) && companyList.length > 0">
              <div v-for="(treelist,index) in companyList"
                   class="box"
                   :key="index"
                   :class="index!==0?'mt-5':''"
                   style="border-radius:8px;border: 1px solid #e8e8e8;">
                <v-treeview hoverable
                            open-on-click
                            selected-color="primary"
                            transition
                            item-key="uuid"
                            item-children="children"
                            expand-icon="arrow_drop_down"
                            :items="[treelist]">
                  <template v-slot:label="{ item }">
                    {{ INT(item.org_level_name) }}
                  </template>
                  <template v-slot:append="{ item }">
                    <menu-list @handleClick="handleClick($event, item)"
                               :list="[
                      {
                        name: $t('label_View'),
                        type: 'view',
                        show: hasBtn('view-organizaiton-configuration'),
                      },
                      {
                        name: $t('label_Edit'),
                        type: 'edit',
                        show: hasBtn('edit-organizaiton-configuration'),
                      },
                      {
                        name: $t('label_delete'),
                        type: 'del',
                        show: hasBtn('delete-organization-configuration'),
                      },
                    ]">
                      <template v-slot:showAction>
                        <v-icon v-btnAuth="[
                          'view-organizaiton-configuration',
                          'edit-organizaiton-configuration',
                          'delete-organization-configuration',
                        ]">mdi-dots-vertical</v-icon>
                      </template>
                    </menu-list>
                  </template>
                </v-treeview>
              </div>

            </template>
            <template v-else>
              <mrc_ess_noContent></mrc_ess_noContent>
            </template>
          </v-card-text>
        </v-card>
      </mrc_ess_skeleton_loader>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { get_company_list, get_company_del } from '@/service/api/company_set'
export default {
  components: {},
  props: {},
  data () {
    return {
      companyList: [],
      skLoading: false,
    }
  },
  async created () {
    await this.getBtnPermissionList()
  },
  async mounted () {
    if (this.$route.name == 'enterprise') {
      await this.getList()
      this.skLoading = false
    }
  },
  methods: {
    delData (uuid) {
      this.Recursion(this.companyList, uuid)
    },
    Recursion (arr, uuid) {
      if (arr.length <= 0) return ''
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1)
        } else {
          if (item.children) {
            this.Recursion(item.children, uuid)
          }
        }
      })
    },
    // 获取公司列表
    async getList () {
      this.skLoading = true
      let obj = {}
      if (this.$store.state.userData.userType == 2) {
        obj = {
          client_uuid: this.$store.state.userData.clientUuid,
          org_level_uuid: this.$store.state.currentCompanyObj.uuid,
          org_level_code: this.$store.state.currentCompanyObj.org_level_code,
        }
      } else {
        obj = {
          client_uuid: this.$store.state.userData.clientUuid,
        }
      }
      const list = await get_company_list(obj)
      if (list.code == 200) {
        this.companyList = list.data ? list.data : []
      }
      this.skLoading = false
    },
    // 跳转添加公司页面
    handleAdd () {
      this.$router.push({
        name: 'addCompany',
      })
    },
    handleClick ({ item, index }, obj) {
      switch (item.type) {
        case 'view':
          this.$store.commit('set_subPage_name', obj.org_level_name)
          this.$store.commit('set_listObj', obj)
          this.$store.commit('set_uuid', obj.uuid)
          this.$store.commit('set_uuid2', obj.client_uuid)
          this.$store.commit('setOrgLevelCode', obj.org_level_code)
          this.$store.commit('set_iconstatus', true)
          this.$router.push({
            name: 'enterpriseInfo',
            params: {
              name: obj.org_level_name,
              uuid: obj.uuid,
            },
          })
          break
        case 'edit':
          this.$store.commit('set_subPage_name', obj.org_level_name)
          this.$store.commit('set_listObj', obj)
          this.$store.commit('set_uuid', obj.uuid)
          this.$store.commit('set_uuid2', obj.client_uuid)
          this.$store.commit('setOrgLevelCode', obj.org_level_code)
          this.$store.commit('set_iconstatus', false)
          this.$router.push({
            name: 'enterpriseInfo',
            params: {
              name: obj.org_level_name,
              uuid: obj.uuid,
            },
          })
          break
        case 'del':
          this.$myConfirm({
            content: this.$t('message_Confirm_the_deletion'),
          })
            .then(async () => {
              const del = await get_company_del({ uuid: obj.uuid })
              if (del.code == 200) {
                this.delData(obj.uuid)
                this.$Message({
                  text: this.$t('message_The_deletion_was_successful'),
                })
                if (
                  this.$store.state.userData.userType != 1 &&
                  this.$store.state.userData.userType != 4
                ) {
                  await this.$store.dispatch('set_topcompanylist')
                }
              }
            })
            .catch(() => { })
          break
      }
    },
  },
  computed: {},
  watch: {
    async $route (val) {
      if (val.name == 'enterprise') {
        await this.getList()
        this.$store.commit('setTab', 0)
      }
    },
  },
}
</script>

<style scoped>
/* /deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
/deep/ .v-treeview-node__root:last-child {
  border-bottom: none;
} */
/* /deep/ .v-treeview {
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-bottom: none;
} */
/* /deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
} */
</style>
